import { render, staticRenderFns } from "./PortalDownloadResultado.vue?vue&type=template&id=7e8d16e9&"
import script from "./PortalDownloadResultado.vue?vue&type=script&lang=js&"
export * from "./PortalDownloadResultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports